<script>
import debounce from 'lodash/debounce';
import enterView from 'enter-view';

export default {
  name: 'TheAnchorNav',
  props: {
    label: {
      type: String,
      default: 'Jump to',
    },
  },
  data() {
    return {
      currentIndex: null,
      currentActive: null,
      targets: [],
      isMobile: false,
      prevIsMobile: null,
    };
  },
  mounted() {
    this.setVars();
    if(this.$refs.content) {
      const headings = Array.from(this.$refs.content.querySelectorAll('[data-anchor]'));

      headings.forEach((heading) => {
        this.targets.push(heading);
        heading.setAttribute('data-ref', heading.id);
        heading.setAttribute('data-label', heading.dataset.anchor);
      });
    }

    this.$nextTick(() => {
      if(this.$refs.list) {
        this.links = this.$refs.list.querySelectorAll('a');
      }

      window.addEventListener('resize', debounce(() => this.resize(), 300));

      this.initScrollers();
    });
  },
  methods: {
    setVars() {
      this.isMobile = window.innerWidth < 992;
    },

    initScrollers() {
      /* eslint-disable no-return-assign */
        if(this.targets.length > 0) {
          this.titlesScroller = enterView({
            offset: 0.9,
            selector: this.targets,
            enter: (e) => this.currentActive = e.dataset.ref,
            exit: (e) => this.currentActive = e.dataset.ref,
          });
      }
      /* eslint-enable */

      if(this.$el.querySelector('.anchors-nav__dropdown')) {
        this.dropdownScroller = enterView({
            offset: 0.95,
            selector: '.anchors-nav__dropdown',
            enter: (e) => e.classList.add('has-reached-top'),
            exit: (e) => e.classList.remove('has-reached-top'),
        });
      }

      if(this.$el.querySelector('.anchors-nav__expand')) {
        this.expandScroller = enterView({
          offset: 0.95,
          selector: '.anchors-nav__expand',
          enter: (e) => e.classList.add('has-reached-top'),
          exit: (e) => e.classList.remove('has-reached-top'),
        });
      }
    },
    resize() {
      this.setVars();
    },
    scrollTo(t) {
      let target = t;
      let offset = 20; // Default offset, so it can breath

      if (typeof target === 'string') {
        target = this.$refs.content.querySelector(`#${t}`);
      }

      const scrollTop = window.pageYOffset + Math.round(target.getBoundingClientRect().top);

      if (scrollTop < window.scrollY) {
        offset += parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      }

      if (this.isMobile) {
        offset += this.$refs.nav.clientHeight;
      }

      window.scrollTo({
        behavior: 'smooth',
        top: scrollTop - offset,
      });
    },
  },
};
</script>
